import React from 'react'
import './Footer.css'
const Footer = () => {
  return (
    <>
    <footer>
        <div className="first">
            <h2>Lorem ipsum dolor sit amet.</h2>
            <a href="mailto:santonunaskar22@gmail.com">santonunaskar@gmail.com</a>
            <a href="mailto:santonunaskar22@gmail.com">8240402210</a>
        </div>
        <div className="second">
            <p>about us</p>
            <p>contact us</p>
            <p>Term & condition</p>
        </div>
        <div className="sotial">
            <p>linkedin</p>
            <p>Glassdoor</p>
            <p>Insta</p>
        </div>
    </footer>
    <div className="end"> &copy; by santonu</div>
    </>
  )
}

export default Footer